"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const react_dropzone_1 = require("react-dropzone");
const CloudUpload_1 = __importDefault(require("@material-ui/icons/CloudUpload"));
const AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));
const Movie_1 = __importDefault(require("@material-ui/icons/Movie"));
const styles_1 = require("@material-ui/core/styles");
const TGRadioField_1 = __importDefault(require("./TGRadioField"));
const common_1 = require("../../utils/common");
const lodash_1 = __importDefault(require("lodash"));
const FieldHeader_1 = __importStar(require("./FieldHeader"));
const DialogueWrapper_1 = __importDefault(require("../Common/DialogueWrapper"));
const TGPreviewField_1 = __importDefault(require("./TGPreviewField"));
const uuid_1 = require("uuid");
const Common_1 = require("./Common");
const TGLabelWrapper_1 = __importDefault(require("./TGLabelWrapper"));
var Capture;
(function (Capture) {
    Capture["UPLOAD"] = "0";
    Capture["DEVICE_CAMERA"] = "1";
})(Capture || (Capture = {}));
var CameraOptions;
(function (CameraOptions) {
    CameraOptions["SYSTEM_CAMERA"] = "1";
})(CameraOptions || (CameraOptions = {}));
const CaptureArea = props => {
    const { captureLabel, fileUploadLabel, deviceUploadLabel, captureType, setCaptureType, camera, setCamera } = props;
    const captureAreaStyles = useCaptureAreaStyles();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(TGRadioField_1.default, { label: captureLabel, options: [
                {
                    value: Capture.UPLOAD,
                    label: fileUploadLabel,
                },
                {
                    value: Capture.DEVICE_CAMERA,
                    label: deviceUploadLabel,
                },
            ], defaultValue: Capture.UPLOAD, onChange: (x) => setCaptureType(x.target.value) }),
        captureType === Capture.DEVICE_CAMERA && (react_1.default.createElement(TGRadioField_1.default, { value: camera, className: captureAreaStyles.dropdown, label: 'Select camera', options: [
                {
                    value: CameraOptions.SYSTEM_CAMERA,
                    label: 'System camera',
                },
            ], onChange: (evt) => {
                setCamera(evt.target.value);
            } }))));
};
const useCaptureAreaStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    dropdown: {
        width: '250px',
        marginBottom: '20px',
    },
}));
const UploadCount = props => {
    const { min, max, length, readOnly } = props;
    const uploadCountStyles = useUploadCountStyles();
    return (react_1.default.createElement("div", { style: { marginTop: 8 } },
        react_1.default.createElement(core_1.Typography, { className: uploadCountStyles.texts, display: "inline" }, `${length} added`),
        !readOnly && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { className: uploadCountStyles.texts, display: "inline" },
                react_1.default.createElement("span", null, "Required: "),
                min),
            react_1.default.createElement(core_1.Typography, { className: uploadCountStyles.texts, display: "inline" },
                react_1.default.createElement("span", null, "Allowed: "),
                max > -1 ? max : 'unlimited')))));
};
const useUploadCountStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    texts: {
        marginRight: '17px',
        marginTop: '10px',
        fontSize: '14px',
        fontFamily: 'Lato',
        textAlign: 'left',
        verticalAlign: 'top',
        color: '#222222',
        '& span': {
            fontWeight: 'bold',
        },
    },
}));
const DropZone = props => {
    const { dragLabel, allowedTypes, updateFileList, error, mediaType } = props;
    const extensions = (0, common_1.useExtensions)(allowedTypes, ',');
    const extensionsLabel = (0, common_1.useExtensions)(allowedTypes, ' | ');
    const dropZoneStyles = useDropzoneStyles();
    const { getRootProps, getInputProps, isDragActive } = (0, react_dropzone_1.useDropzone)({ onDrop: updateFileList, noClick: true });
    let icon = react_1.default.createElement(AddPhotoAlternate_1.default, null);
    if (mediaType === 'video' || mediaType === 'audio')
        icon = react_1.default.createElement(Movie_1.default, null);
    return (react_1.default.createElement("div", Object.assign({ className: (0, clsx_1.default)(dropZoneStyles.fileuploader, isDragActive && dropZoneStyles.dragActive) }, getRootProps()),
        react_1.default.createElement("div", { id: "upload-label", style: { width: '200px', margin: 'auto', textAlign: 'center' } },
            react_1.default.createElement(CloudUpload_1.default, { color: "disabled", style: { fontSize: 120 } }),
            react_1.default.createElement("br", null)),
        react_1.default.createElement("div", { style: { width: '100%', margin: 'auto', textAlign: 'center' } },
            react_1.default.createElement(core_1.Typography, { className: dropZoneStyles.title }, dragLabel),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { className: dropZoneStyles.title }, "or"),
            react_1.default.createElement("input", Object.assign({}, getInputProps(), { accept: extensions, style: { display: 'none' }, id: "contained-button-file", onChange: (evt) => {
                    const files = lodash_1.default.get(evt, 'target.files');
                    updateFileList(files);
                }, multiple: true, type: "file" })),
            react_1.default.createElement("label", { htmlFor: "contained-button-file" },
                react_1.default.createElement(core_1.Button, { variant: "contained", color: "default", className: dropZoneStyles.uploadbtn, startIcon: icon, component: "span" }, "Upload")),
            react_1.default.createElement(core_1.Typography, { className: (0, clsx_1.default)(dropZoneStyles.title, dropZoneStyles.formats) }, extensionsLabel),
            error && react_1.default.createElement(core_1.Typography, { className: dropZoneStyles.errorText }, error))));
};
const useDropzoneStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    fileuploader: {
        position: 'relative',
        height: '400px',
        border: `4px dashed ${theme.palette.secondary.main}`,
        background: '#f6f6f6',
        margin: '10px 8px',
        paddingTop: '50px',
    },
    dragActive: {
        border: `4px dashed ${theme.palette.primary.main}`,
    },
    title: {
        position: 'relative',
        color: theme.palette.grey[400],
        textAlign: 'center',
    },
    uploadbtn: {
        margin: '20px',
    },
    formats: {
        fontSize: '13px',
    },
    errorText: {
        color: '#eb5757',
        position: 'relative',
        textAlign: 'center',
        marginTop: '30px',
    },
}));
const useMediaFieldStyles = (0, styles_1.makeStyles)({
    content: {
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: `calc(100% - ${FieldHeader_1.FIELD_HEADER_HEIGHT}px)`,
        overflowY: 'auto',
        boxSizing: 'border-box',
    },
});
const TGMediaField = props => {
    const { addFiles, removeFiles, toggleModal, files } = props;
    const [captureType, setCaptureType] = (0, react_1.useState)(Capture.UPLOAD);
    const [uploadError, setUploadError] = (0, react_1.useState)(null);
    const [fileList, setFileList] = (0, react_1.useState)(files || []);
    const [addedFiles, setAddedFiles] = (0, react_1.useState)([]);
    const [removedFiles, setRemovedFiles] = (0, react_1.useState)([]);
    const [camera, setCamera] = (0, react_1.useState)(CameraOptions.SYSTEM_CAMERA);
    const classes = useMediaFieldStyles();
    const onDonePress = () => {
        addFiles(fileList.filter((x) => addedFiles.find((id) => id === x.id)));
        removeFiles(removedFiles);
        toggleModal && toggleModal();
    };
    const onDeleteFile = (id) => {
        setFileList(fileList.filter(x => x.id !== id));
        setRemovedFiles([...removedFiles, id]);
    };
    const onCancelPress = () => {
        toggleModal && toggleModal();
    };
    const { label, captureLabel, fileUploadLabel, deviceUploadLabel, dragLabel, allowedTypes, limitInMb, min, max, renderMedia, mediaType, } = props;
    const isValidLimit = (size) => size / 1024 / 1024 <= limitInMb;
    const addFileToList = (file) => {
        updateFileList([file]);
    };
    const updateFileList = (fileObjects) => {
        if (fileObjects && fileObjects.length) {
            const files = [...fileObjects];
            if (!files.every(file => isValidLimit(file.size))) {
                setUploadError(`Oops, the selected file is over the ${limitInMb} mb limit. Please choose a smaller file`);
                return;
            }
            setUploadError(null);
            const list = files.map((file) => {
                const splitPath = file.name.split('.');
                const extension = splitPath[splitPath.length - 1];
                return {
                    id: `${(0, uuid_1.v4)()}.${extension}`,
                    file: file,
                    url: URL.createObjectURL(file),
                };
            });
            setFileList([...fileList, ...list]);
            setAddedFiles([...addedFiles, ...list.map(x => x.id)]);
        }
    };
    return (react_1.default.createElement(core_1.FormControl, null,
        react_1.default.createElement(FieldHeader_1.default, { title: label, canSave: !!fileList.length, onDonePress: onDonePress, onCancelPress: onCancelPress }),
        react_1.default.createElement(core_1.Box, { pt: 3, className: classes.content },
            react_1.default.createElement(CaptureArea, { captureLabel: captureLabel, fileUploadLabel: fileUploadLabel, deviceUploadLabel: deviceUploadLabel, captureType: captureType, setCaptureType: setCaptureType, camera: camera, setCamera: setCamera }),
            react_1.default.createElement(UploadCount, { max: max, min: min, length: fileList.length }),
            captureType === Capture.DEVICE_CAMERA && camera === CameraOptions.SYSTEM_CAMERA ? (renderMedia && renderMedia(addFileToList)) : (react_1.default.createElement(DropZone, { dragLabel: dragLabel, allowedTypes: allowedTypes, updateFileList: updateFileList, error: uploadError, mediaType: mediaType })),
            react_1.default.createElement(TGPreviewField_1.default, { files: fileList, onModal: true, thumbnailSize: 100, onDelete: onDeleteFile }))));
};
const DefaultView = props => {
    const { min, max, removeFiles, files, readOnly, warning } = props;
    const [tooltip, setTooltip] = (0, react_1.useState)(false);
    const classes = (0, Common_1.useStyles)();
    return (react_1.default.createElement("div", { onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) },
        react_1.default.createElement(DialogueWrapper_1.default, Object.assign({}, props, { clearValue: () => removeFiles(files.map(file => file.id)), position: 'bottom', renderHeader: () => {
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(core_1.InputLabel, { error: props.error, className: (0, clsx_1.default)(warning && classes.warningText) },
                        react_1.default.createElement(TGLabelWrapper_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: tooltip })),
                    react_1.default.createElement(UploadCount, { min: min, max: max, length: files.length, readOnly: readOnly })));
            }, renderValue: () => {
                return (react_1.default.createElement("div", null,
                    !!files.length && (react_1.default.createElement(TGPreviewField_1.default, { files: files, thumbnailSize: 80, onModal: true, onDelete: id => removeFiles([id]) })),
                    react_1.default.createElement(core_1.FormHelperText, { error: props.error, className: (0, clsx_1.default)(warning && classes.warningText) }, props.helperText)));
            }, renderComponent: toggleModal => {
                return react_1.default.createElement(TGMediaField, Object.assign({}, props, { toggleModal: toggleModal }));
            } }))));
};
exports.default = DefaultView;
//# sourceMappingURL=TGMediaField.js.map